export const STATE_PROP_NAME = 'companiesPage'
export const PAGE_SIZE = 20
